type SignatureCanvasBox = {
  width: number;
  height: number;
  getBoundingClientRect(): { left: number; top: number; width: number; height: number };
};

type SignaturePointerEvent =
  | { clientX: number; clientY: number }
  | { touches: ArrayLike<{ clientX: number; clientY: number }> };

/**
 * Map a pointer on the visible canvas into the backing bitmap.
 * The backing size stays fixed; only the current box is read.
 */
export function signatureCanvasPoint(
  canvas: SignatureCanvasBox,
  event: SignaturePointerEvent
): { x: number; y: number } {
  const rect = canvas.getBoundingClientRect();
  const clientX = 'touches' in event ? event.touches[0].clientX : event.clientX;
  const clientY = 'touches' in event ? event.touches[0].clientY : event.clientY;
  return {
    x: (clientX - rect.left) * (canvas.width / rect.width),
    y: (clientY - rect.top) * (canvas.height / rect.height)
  };
}
